import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';
import { Stack } from 'common/ui/Layout';
import { Colors } from 'styles';
import type { SlateContent } from 'domains/reporter/Reporter/types';
import { MacroTooltipHeader } from './MacroTooltipHeader';
import { MacroTooltipPreviewBody } from './MacroTooltipPreviewBody';

type MacroPlaceholderChipPreviewProps = {
  macroName: string;
  macroContent: Nullable<SlateContent>;
  isLoading?: boolean;
  compact?: boolean;
};

export const MacroPlaceholderChipPreview = ({
  macroName,
  macroContent,
  isLoading = false,
  compact = false,
}: MacroPlaceholderChipPreviewProps): React.ReactElement => {
  return (
    <PreviewCard vertical space="small">
      <MacroTooltipHeader macroName={macroName} compact={compact} />
      {isLoading ? (
        <Stack alignX="center" alignY="center">
          <CircularProgress size="2rem" />
        </Stack>
      ) : (
        <MacroTooltipPreviewBody
          macroContent={macroContent}
          maxHeight={compact ? 220 : 280}
          testID="macro-placeholder-chip-preview-body"
        />
      )}
    </PreviewCard>
  );
};

const PreviewCard = styled(Stack)`
  width: fit-content;
  max-width: min(42rem, 72vw);
  padding: 1.2rem;
  border-radius: 1.2rem;
  border: 1px solid ${Colors.gray6};
  background: ${Colors.gray4};
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.28);
`;
